<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">Reporte de caja chica</h2>
    <MainPettyCashReport />
  </div>
</template>

<script>
import MainPettyCashReport from "@/components/PettyCash/MainPettyCashReport.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";

export default {
  name: "PettyCashReportView",
  components: {
    MainPettyCashReport,
  },
  setup() {
    const route = useRoute();

    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>